import React from "react";
import { motion } from "framer-motion";
import { Gift, Megaphone, Briefcase, Store, Truck, Globe, Send, Sparkles } from "lucide-react";

const services = [
  { icon: Gift, title: "Corporate Gifts", desc: "Curated premium gifts for clients, partners & leadership." },
  { icon: Megaphone, title: "Promotional Products", desc: "Branded merchandise that keeps you top-of-mind." },
  { icon: Briefcase, title: "New Hire Kits", desc: "Welcome kits that onboard talent in style." },
  { icon: Store, title: "Company Brand Stores", desc: "A private online store curated to your brand." },
  { icon: Truck, title: "Drop Ship & Warehousing", desc: "We store, pack & ship — anywhere, anytime." },
  { icon: Globe, title: "Global Gifting", desc: "Seamless international delivery across borders." },
  { icon: Send, title: "E-Gifting Solutions", desc: "Instant digital gift cards & redemption links." },
  { icon: Sparkles, title: "Seasonal & Festival Gifts", desc: "Diwali & festive hampers, delivered in 2 days." },
];

const Services = () => {
  return (
    <section id="services" className="relative z-10 scroll-mt-28 bg-[#0B0F19] py-24 md:py-32" data-testid="services-section">
      <div className="pointer-events-none absolute left-0 top-1/3 h-96 w-96 bloom-indigo opacity-50" />
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-14 max-w-2xl"
        >
          <span className="font-sans text-xs uppercase tracking-[0.3em] text-[#D4AF37]">What we do</span>
          <h2 className="mt-5 font-serif text-4xl leading-[1.08] tracking-tight text-[#F3EEE3] md:text-5xl">
            Gifting solutions that build the{" "}
            <span className="italic text-[#D4AF37]">strongest connections</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.55, delay: (i % 4) * 0.08, ease: [0.22, 1, 0.36, 1] }}
                className="group relative overflow-hidden rounded-xl border border-[#F3E5AB]/10 bg-[#111826] p-7 transition-all duration-500 hover:border-[#D4AF37]/50 hover:shadow-[0_0_36px_rgba(212,175,55,0.14)]"
                data-testid={`service-${i}`}
              >
                <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-full border border-[#D4AF37]/30 bg-[#D4AF37]/5 text-[#D4AF37] transition-all duration-300 group-hover:border-[#D4AF37]/70 group-hover:shadow-[0_0_20px_rgba(212,175,55,0.4)]">
                  <Icon className="h-5 w-5" strokeWidth={1.5} />
                </div>
                <h3 className="font-serif text-xl tracking-tight text-[#F3EEE3]">{s.title}</h3>
                <p className="mt-2 font-sans text-sm leading-relaxed text-[#8B93A7]">{s.desc}</p>
                <span className="mt-4 inline-block font-sans text-xs uppercase tracking-[0.15em] text-[#D4AF37]/70 transition-colors duration-300 group-hover:text-[#D4AF37]">
                  Know more →
                </span>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
